exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".multiText {\n  font-size: 10px;\n  font-family: sans-serif; }\n\n.ListParent {\n  padding-left: 40px;\n  display: grid;\n  grid-template-columns: repeat(5, auto); }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/lib/loader.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/d3Components/MultiLineChart/legend.scss
// module id = 897
// module chunks = 0